module.exports = __webpack_public_path__ + "img/bukalapak.aeeb2c31.png";